/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const audioPartEnum = z.enum(['title', 'definition', 'usageNotes', 'examples']);

export type AudioPartType = z.infer<typeof audioPartEnum>;

export const generateAllAudioBodySchema = z.object({
  force: z.boolean().optional().default(false),
  parts: z.array(audioPartEnum).optional(),
});

export type IGenerateAllAudioBody = z.input<typeof generateAllAudioBodySchema>;
